import { productSearchQueryAllowedList } from '@shared/utils/src/algolia';
import { getIndexedStoresList } from '@shared/utils/src/ct/index';

export const isAllowedAlgoliaAttribute = (attribute: string): boolean => {
  const allowedList = productSearchQueryAllowedList(getIndexedStoresList());
  return allowedList.includes(attribute);
};
